import React from "react";

export default function Description() {
  return (
    <p>
      {" "}
      مشتری گرامی
      <br />
      خواهشمند است با دقت راهنمای همکاری با تکنوحساب را مطالعه و رعایت فرمائید:
      <br />
      <br /> 1- با خبر بمانید : ما تمام مشتریان قراردادی رو عضو کانال ایتا مون
      میکنیم ، تو این کانال اخبار خیلی خیلی مهم مالیاتی مثل بخشنامه های بخشش
      جرائم و یادآوری انجام تکالیف مالیاتی رو میذاریم.
      <br />
      • از ترک کانال یا حذف ایتا خودداری فرمائید.
      <br />
      • چون تمام مشتریان تو این کانال عضو هستند ، تمام تکالیف هم یادآوری میشود ،
      پس از دیدن پیام ، اگر مربوط به شما میشود ، اقدام فرمائید.
      <br />
      • اگه اعلان های ایتا رو فعال نکردین(یعنی وقتی پیام میاد شما متوجه نمیشین)
      تو کانال آموزش فعال کردنش رو گذاشتیم،ببینید و فعال کنید. #اعلان رو تو
      کانال جستجو کنید.
      <br />
      • لطفا حداکثر 5 روز پس از یادآوری تکلیف ، اطلاعات مورد نیاز را ، ارسال
      فرمائید.هیچ وقت کاری رو برای روزای آخر نذارین،چون روزای آخر به دلیل شلوغی
      سامانه ها ، بانک ها،پیامک ها و... مشکل دارن و ممکنه کارتون انجام
      نــشه(درصورتیکه ارسال اطلاعات رو برای روزای آخر گذاشتین،مسئولیت انجام شدن
      یا نشدن کار به عهده شماست)
      <br />
      • لطفا بعد از ارسال اطلاعات ، تعداد فایل های ارسالی را هم اعلام کنید(مثلا
      4 فاکتور خرید و 12 فاکتور فروش) و منتظر تاییدیهِ دریافت اطلاعات(👍) ، از
      طرف ما بمانید. درصورت گذشت 24 ساعت و عدم دریافت تاییدیه از ما ، لطفا به
      صورت تلفنی اطلاع بدین.
      <br /> <br />
      2- امنیت اسناد و مدارک: ما تمامی اسناد و مدارک شما رو طول سال در بایگانی
      خودمون نگهداری میکنیم تا ایمن و منظم بمونه و لازمه در ماه های آخر سال که
      اطلاع میدیم ، به ما مراجعه کنید تا کل مدارک اون سال رو بهتون تحویل بدیم،تا
      مجدد فضای بایگانی برای سال بعد آزاد بشه.
      <br />
      • برای اینکه هر سندی رو سریعتر بتونید پیدا کنید ، مدارک هر سال رو در پوشه
      یا کاور جدا نگهداری کنید و عدد سال رو روی اون بنویسین.
      <br />
      • پوشه یا کاور های هر سال رو در جای مطمئن و پیش هم نگهداری کنید.
      <br />
      <br />
      3- ارتباط آسان تر : تمام شماره های ما رو به نام های زیر در موبایل خود
      ذخیره کنید:
      <br />
      فتوحی تکنوحساب 09140704236
      <br />
      دفتر تکنوحساب 03532220053 - 09900200142
      <br />
      سامانه پیامک تکنوحساب 5000433233
      <br />• پاسخگویی‌تلفنی حوالی ساعت 9 الی 13 و 17 الی 20 هست ، در‌صورتیکه
      خارج از این ساعات ، کاری داشتین میتونید تو ایتـا شماره اولی پیام یا ویس
      بفرستین.(تمام این تلفن ها همیشه تو دفتر هست،اما ایتا همراهمون هست)
      <br />
      • سامانه پیامکی امکان دریافت پیامک نداره،یعنی اگه شما پیامکی به این شماره
      بفرستین به دست ما نمیرسه.
      <br />
      • هر پیامکی که از طرف مالیات براتون اومد ، همون لحظه برای ایـتـا شماره
      اولی بفرستین ، چون پیامک های مالیاتی طولانیه و نمیتونید با گوشی ارسال
      کنید.(سعی کنید همیشه همه پیام ها رو تو ایتـا بفرستین،چون هر روز به ترتیب
      پیام هایی که تو ایتا اومده کار ها رو انجام میدیم)
      <br />
      • زمانیکه برای دریافت پاسخ یک سوال پیام دادین ، مجدد نقطه یا علامت‌سوال و
      … ارسال نکنید ، چون تمامی پیامها از پایین به ترتیب پاسخ میدیم.
      <br />
      <br />
      4- پشت در نمانید : تمام خدمات ما به صورت آنلاین و تلفنی خـیـلـی راحــت‌تـر
      انجام میشه ، اما
      <br />
      • ساعت کاری ، حوالی 9 الی 13 روز های کاری
      <br />
      • در صورتیکه نیاز به مراجعه حضوری داشتین و صبح نمیتونستین بیاین ، تلفنی
      هماهنگ کنید برای یک روز بعد از ظهر
      <br />
      <br />
      5- دفتر ما کجاست؟
      <br />• از طرف خیابان ابوالفضل : خیابان ام البنین(کوچه مسجد ابوالفضل) ،
      کوچه 8
      <br />
      • از طرف بلوار خاتمی : کوچه روبروی مسجد اعرابی ، بعد از چهارراه
      <br />
      <br />
      6- مدت قرارداد چقدر است؟
      <br />
      • از تاریخ پرداخت ، لغایت پایان سال تقویمی (مثلا اظهارنامه ارزش افزوده
      زمستان امسال چون در سال بعد ارسال میشود،در قرارداد سال بعد میآید)
      <br />
      <br />
      7- مبلغ قرارداد بر چه اساسی تعیین میشود؟
      <br />
      • مبلغ قرارداد با توجه به برآورد خدمات مورد‌نیازشما(که در قسمت نمایش
      قرارداد آمده) و نوع و حجم آن در مدت‌زمان قرارداد ، تعیین میشود.
      <br />
      • خدمات مازاد بر قرارداد ، بصورت جداگانه فاکتور میگردد.
      <br />• در صورتیکه در طول مدت قرارداد ، نیاز به افزودن خدمتی جدید باشد یا
      نوع ویا حجم خدمات ذکرشده در قرارداد تغییر کند ، نسخه اصلاحی قرارداد تنظیم
      و مبلغ مابه‌التفاوت نیز ، در همان ماه باید تسویه شود.
      <br />• در صورت عدم‌پرداخت در 6 ماهه اول سال ، قرارداد بصورت یکطرفه فسخ و
      تکنوحساب هیچگونه مسئولیتی بابت انجام خدمات مشتری ندارد.
      <br />
      پرداخت قسمتی یا کل مبلغ قرارداد ، به‌منزله تایید کل شرایط همکاری میباشد.
      <br />
      <br />
      سوالی داشتین خوشحال میشیم کمکتون کنیم.
    </p>
  );
}
